'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('@iyunbao/utils');

var _toast = require('../../toast');

var _toast2 = _interopRequireDefault(_toast);

var _fetch = require('../../utils/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AntiBrush = function (_PureComponent) {
  _inherits(AntiBrush, _PureComponent);

  function AntiBrush(props) {
    _classCallCheck(this, AntiBrush);

    var _this = _possibleConstructorReturn(this, (AntiBrush.__proto__ || Object.getPrototypeOf(AntiBrush)).call(this, props));

    _this.loadJS = function () {
      return new Promise(function (resolve) {
        if (typeof initNECaptcha !== 'undefined') {
          resolve();
          return false;
        }

        _utils.load.js('//cstaticdun.126.net/load.min.js', function () {
          resolve();
        });
      });
    };

    _this.ceate = function () {
      var _this$props = _this.props,
          captchaId = _this$props.captchaId,
          _onClose = _this$props.onClose,
          params = _objectWithoutProperties(_this$props, ['captchaId', 'onClose']);

      _this.loadJS().then(function () {
        window.initNECaptcha({
          // config对象，参数配置
          captchaId: captchaId,
          element: '#anti-slider',
          mode: 'bind',
          onReady: function onReady(instance) {
            if (instance) {
              instance.verify();
            }
          },
          onClose: function onClose() {
            _onClose();
          },
          onVerify: function onVerify(err, data) {
            if (err) {
              return false;
            }

            if (data && data.validate) {
              params.neCaptchaValidate = data.validate;
            }

            _this.verify(params);
          }
        });
      });
    };

    _this.verify = function (params) {
      var _this$props2 = _this.props,
          onSuccess = _this$props2.onSuccess,
          onClose = _this$props2.onClose;


      _fetch2.default.fetch({
        path: '/facilities/open/v1/common/security/yidun/ticket',
        server: 'api',
        method: 'POST',
        data: params,
        timeout: 7000
      }).then(function (_ref) {
        var code = _ref.code,
            result = _ref.result,
            message = _ref.message;

        if (+code === 0 && result) {
          onSuccess && onSuccess(result.ticket);
        } else {
          onClose && onClose();
          message && _toast2.default.warning(message);
        }
      }).catch(function () {
        onClose && onClose();
      });
    };

    _this.state = {};

    _this.ceate();
    return _this;
  }

  _createClass(AntiBrush, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { id: 'anti-slider' });
    }
  }]);

  return AntiBrush;
}(_react.PureComponent);

AntiBrush.defaultProps = {
  bizType: '',
  data: '',
  sTokenId: '',
  captchaId: '43bce36e5a6a4b5c9c9b61ae7b077ffd',
  onSuccess: function onSuccess() {},
  onClose: function onClose() {}
};
AntiBrush.propTypes = {
  bizType: _propTypes2.default.string,
  data: _propTypes2.default.string,
  sTokenId: _propTypes2.default.string,
  captchaId: _propTypes2.default.string,
  onSuccess: _propTypes2.default.func,
  onClose: _propTypes2.default.func
};
exports.default = AntiBrush;